export default {
    recordDeviceMetadata(){
        const readText = (read) => {
            try {
                const value = read();
                return typeof value === 'string' ? value.trim() : '';
            } catch (_) {
                return '';
            }
        };
        const language = readText(() => navigator.language || (navigator.languages || [])[0]);
        const timezoneName = readText(() => Intl.DateTimeFormat().resolvedOptions().timeZone);
        const offset = readText(() => {
            const minutes = -new Date().getTimezoneOffset();
            if (!Number.isFinite(minutes)) return '';
            const hours = String(Math.floor(Math.abs(minutes) / 60)).padStart(2, '0');
            const remainder = String(Math.abs(minutes) % 60).padStart(2, '0');
            return `UTC${minutes < 0 ? '-' : '+'}${hours}:${remainder}`;
        });
        return {
            language,
            timezone: timezoneName && offset ? `${timezoneName} (${offset})` : timezoneName || offset,
        };
    },
    loginDeviceData(){
        const userAgent = navigator.userAgent;
        const browsers = [
            {name: 'Edge', pattern: /(?:EdgA|EdgiOS|Edg)\/([\d.]+)/},
            {name: 'Opera', pattern: /(?:OPR|Opera)\/([\d.]+)/},
            {name: 'Samsung Internet', pattern: /SamsungBrowser\/([\d.]+)/},
            {name: 'Chrome', pattern: /(?:CriOS|Chrome)\/([\d.]+)/},
            {name: 'Firefox', pattern: /(?:FxiOS|Firefox)\/([\d.]+)/},
            {name: 'Safari', pattern: /Version\/([\d.]+).*Safari\//},
        ];
        const detectedBrowser = browsers.find(({pattern}) => pattern.test(userAgent));
        let browser = 'Navegador';
        if (detectedBrowser) {
            const version = userAgent.match(detectedBrowser.pattern)[1];
            browser = `${detectedBrowser.name} v${version}`;
        }

        let system = (navigator.userAgentData || {}).platform || navigator.platform || 'Sistema desconhecido';
        if (/Android/i.test(userAgent)) system = 'Android';
        else if (/iPhone|iPad|iPod/i.test(userAgent)) system = 'iOS';
        else if (/Windows/i.test(userAgent)) system = 'Windows';
        else if (/Ubuntu/i.test(userAgent)) system = 'Ubuntu';
        else if (/CrOS/i.test(userAgent)) system = 'ChromeOS';
        else if (/Mac OS|Macintosh/i.test(userAgent)) system = 'macOS';
        else if (/Linux/i.test(userAgent)) system = 'Linux';
        return {
            device: `${browser} ${system}`,
            platform: 'web',
            app_version: process.env.VUE_APP_VERSION || null,
        };
    },
    keyPressOnlyNumbers(evt){
        evt = evt || window.event;
        let c = evt.which || evt.keyCode;
        if (48 <= c && c <= 57) {
            return true;
        }
        evt.preventDefault();
    },
    formatMoney(value){
        if (!value && value !== 0){
            return value;
        }
        if (typeof value === 'string' || value instanceof String) {
            value = parseFloat(value);
        }
        let [num, decimal] = value.toFixed(2).split('.');
        let negative = false;
        if (num[0] == '-'){
            num = num.slice(1);
            negative = true;
        }
        let newNum = "";
        while (num.length > 3){
            newNum = '.' + num.slice(-3) + newNum;
            num = num.slice(0, -3);
        }
        return `${negative ? '-':''}${num}${newNum},${decimal}`;
    },
    formattedMoneyToDecimal(str){
        if (!str){
            return str;
        }
        return str.replaceAll(/\./g, '').replace(',', '.');
    },
    formatDate(date){
        if (!date) return undefined;
        if (typeof date != Date){
            if (date.length == '2022-00-00'.length){
                date += " 00:00:00";
            }
            date = new Date(date);
        }
        return date.toLocaleDateString('pt-BR');
    },
    formatTime(time){
        if (typeof time != Date){
            time = new Date(time);
        }
        return time.toLocaleTimeString('pt-BR').split(':').slice(0, 2).join(':');
    },
    formatDateTime(date){
        if (typeof date != Date){
            date = new Date(date);
        }
        return this.formatDate(date) + " " + this.formatTime(date);
    },
    fromBrDatetime(str){
        if (!str){
            return str;
        }
        let date = "", time = "";
        let parts = str.split(' ');
        if (parts.length >= 1){
            date = parts[0];
        }
        if (parts.length >= 2){
            time = parts.slice(1).join(' ');
            if (time){
                time = " " + time;
            }
        }
        if (date){
            date = date.split('/').reverse().join('-');
            if (date.length < '0000-00-00'.length){
                return undefined;
            }
        }
        return date + time;
    },
    strToDateStr(str){
        return new Date(str).toLocaleString('pt-BR')
    },
    sendToClipboard(txt){
        navigator.clipboard.writeText(txt);
    },
}
